<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">

      <!-- Brand logo-->
      <b-link class="brand-logo" to="/">
        <img src="/logo.png" height="30" alt="همکده">
        <h2 class="brand-text text-primary ml-1">
          {{ $t('App.title') }}
        </h2>
      </b-link>
      <!-- /Brand logo-->

      <!-- Login-->
      <b-col
          lg="4"
          class="d-flex align-items-center auth-bg px-2 p-lg-5"
      >
        <b-col
            sm="8"
            md="6"
            lg="12"
            class="px-xl-2 mx-auto"
            v-if="loginPage"
        >
          <b-card-title
              class="mb-1 font-weight-bold"
              title-tag="h2"
          >
            {{ $t('Pages.Login.Title.welcome to system') }} 👋
          </b-card-title>
          <b-card-text class="mb-2">
            {{ $t('Pages.Login.Title.you can login with your mobile number') }}
          </b-card-text>

          <!-- form -->
          <validation-observer
              ref="loginForm"
              #default="{invalid}"
          >
            <b-form @submit.prevent
                class="auth-login-form mt-2"
            >
              <b-form-group
                  label="شماره موبایل"
                  label-for="login-mobile"
              >
                <validation-provider
                    #default="{ errors }"
                    name="شماره موبایل"
                    vid="mobile"
                    rules="required"
                >
                  <b-form-input
                      id="login-mobile"
                      v-model="mobile"
                      :state="errors.length > 0 ? false:null"
                      name="mobile"
                      type="tel"
                      placeholder="شماره موبایل را وارد نمایید"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>


              <b-form-group>
                <b-form-checkbox
                    id="remember-me"
                    v-model="status"
                    name="checkbox-1"
                >
                  مرا به یاد داشته باش
                </b-form-checkbox>
              </b-form-group>

              <!-- submit buttons -->
              <b-button
                  variant="primary"
                  block
                  :disabled="invalid || onProgress"
                  @click="login"
                  type="submit"
              >
                <feather-icon
                    icon="MailIcon"
                    class="mr-50"
                />
                <span class="align-middle">{{ onProgress ? 'در حال ارسال اطلاعات' : 'ورود با پیامک' }}</span>
              </b-button>
            </b-form>
          </validation-observer>
        </b-col>
        <b-col
            sm="8"
            md="6"
            lg="12"
            class="px-xl-2 mx-auto"
            v-else
        >

          <b-card-text class="mb-2">
            برای ورود کد ارسالی به شماره موبایل خود را وارد نمایید.
          </b-card-text>

          <!-- form -->
          <validation-observer
              ref="otpForm"
              #default="{invalid}"
          >
            <b-form
                class="auth-login-form mt-2"
                @submit.prevent="checkOtp"
            >
              <b-form-group
                  label="کد ورود"
                  label-for="login-otp"
              >
                <validation-provider
                    #default="{ errors }"
                    name="کد ورود"
                    vid="otp"
                    rules="required"
                >
                  <b-form-input
                      id="login-otp"
                      v-model="otp"
                      :state="errors.length > 0 ? false:null"
                      name="otp"
                      placeholder="کد ورود را وارد نمایید"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <b-row>
                <b-col>

                  <b-alert
                      v-height-fade.appear
                      variant="info"
                      :show="counting"
                  >
                    <div class="alert-body" v-html="sendAgainText">
                    </div>
                  </b-alert>
                  <b-alert
                      v-height-fade.appear
                      variant="info"
                      :show="!counting"
                  >
                    <div class="alert-body row">

                      <div class="col-12 col-sm-6">
                        ارسال مجدد کد تایید

                      </div>
                      <div class="col-12 col-sm-6">
                        <b-button @click='sendAgain' v-ripple.400="'rgba(255, 255, 255, 0.15)'" size="sm"
                                  variant="primary" class="mx-1"
                        >
                          پیامک شود
                        </b-button>
                      </div>


                    </div>
                  </b-alert>
                </b-col>
              </b-row>

              <!-- submit buttons -->
              <b-button
                  type="submit"
                  variant="primary"
                  block
                  :disabled="onProgress"
              >
                {{ onProgress ? 'در حال ارسال اطلاعات' : 'تأیید کد ورود' }}
              </b-button>
            </b-form>
          </validation-observer>
        </b-col>
      </b-col>
      <!-- /Login-->

      <!-- Left Text-->
      <b-col
          lg="8"
          class="d-none d-lg-flex align-items-center p-5"
      >
        <div class="w-100 d-lg-flex align-items-center justify-content-center px-5">
          <b-img
              fluid
              :src="imgUrl"
              alt="Login V2"
          />
        </div>
      </b-col>
      <!-- /Left Text-->
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver, localize } from 'vee-validate'
import VuexyLogo from '@core/layouts/components/Logo.vue'
import {
  BRow,
  BCol,
  BLink,
  BFormGroup,
  BFormInput,
  BFormCheckbox,
  BCardText,
  BCardTitle,
  BImg,
  BForm,
  BButton,
  BAlert,
  VBTooltip,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { heightFade } from '@core/directives/animations'
import { required } from '@validations'
import store from '@/store/index'

import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import farsi from 'vee-validate/dist/locale/fa'
import { initializeApp } from 'firebase/app'
import { getMessaging, getToken } from 'firebase/messaging'


export default {
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
    'height-fade': heightFade,
  },
  components: {
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BCardText,
    BCardTitle,
    BImg,
    BForm,
    BButton,
    BAlert,
    VuexyLogo,
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      status: '',
      mobile: '',
      sideImg: require('@/assets/images/pages/login.gif'),

      // validation rules
      required,
      onProgress: false,
      loginPage: true,
      otp: '',
      counting: false,
      countdown: 60,
    }
  },
  computed: {
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = require('@/assets/images/pages/login.gif')
        return this.sideImg
      }
      return this.sideImg
    },
    sendAgainText() {
      return this.counting ?
          `<span>ارسال مجدد کد ورود <strong> ${this.countdown} </strong>  ثانیه دیگر</span>` : ''

    },
  },
  methods: {
    login() {
      this.$refs.loginForm.validate()
          .then(success => {
            if (success) {
              this.onProgress = true
              this.$http.post('auth/login', {
                mobile: this.mobile,
              })
                  .then(({ data }) => {
                    if (data.status) {
                      this.loginPage = false
                      this.startCountdown()
                    } else {
                      this.$toast({
                        component: ToastificationContent,
                        position: 'top-right',
                        props: {
                          title: 'ورود ناموفق',
                          icon: 'CoffeeIcon',
                          variant: 'danger',
                          text: data.message,
                        },
                      })
                    }
                  })
                  .catch(error => {
                    this.$toast({
                      component: ToastificationContent,
                      position: 'top-left',
                      props: {
                        title: 'ورود ناموفق',
                        icon: 'CoffeeIcon',
                        variant: 'danger',
                        text: error?.response?.data?.message ?? error.message,
                      },
                    })
                  })
                  .finally(() => {
                    this.onProgress = false
                  })
            }
          })
    },
    checkOtp() {
      this.$refs.otpForm.validate()
          .then(success => {
            if (success) {
              this.onProgress = true
              this.$http.post('auth/check-otp', {
                mobile: this.mobile,
                otp: this.otp
              })
                  .then(({ data }) => {
                    if (data.status) {
                      this.$store.commit('user/UPDATE_USER_DATA', data.user)
                      this.$router.replace('/').catch(()=>{})
                      this.$toast({
                        component: ToastificationContent,
                        position: 'top-right',
                        props: {
                          title: `${data.user.name} عزیز ، خوش آمدید`,
                          icon: 'CoffeeIcon',
                          variant: 'success',
                          text: `شما با موفقیت وارد سیستم شدید`,
                        },
                      })
                      this.firebaseInit()
                    } else {
                      this.$toast({
                        component: ToastificationContent,
                        position: 'top-right',
                        props: {
                          title: 'ورود ناموفق',
                          icon: 'CoffeeIcon',
                          variant: 'danger',
                          text: data.message ?? 'مشکلی در انجام عملیات رخ داده است',
                        },
                      })
                    }
                  })
                  .catch(error => {
                    this.$toast({
                      component: ToastificationContent,
                      position: 'top-left',
                      props: {
                        title: 'ورود ناموفق',
                        icon: 'CoffeeIcon',
                        variant: 'danger',
                        text: error?.response?.data?.message ?? error.message,
                      },
                    })
                  })
                  .finally(() => {
                    this.onProgress = false
                  })
            }
          })
    },
    sendAgain() {
      this.$http.post('auth/login', {
        mobile: this.mobile,
      })
          .then(({ data }) => {
            if (data.status) {
              this.startCountdown()
            }
          })
          .catch(error => {
            this.$toast({
              component: ToastificationContent,
              position: 'top-left',
              props: {
                title: 'ورود ناموفق',
                icon: 'CoffeeIcon',
                variant: 'danger',
                text: error?.response?.data?.message ?? error.message,
              },
            })
          })
          .finally(() => {
            this.onProgress = false
          })
    },
    startCountdown() {
      this.counting = true

      const intervalId = setInterval(() => {
        this.countdown--
        if (this.countdown <= 0) {
          clearInterval(intervalId)
          this.countdown = 60
          this.counting = false
        }
      }, 1000)
    },

    firebaseInit() {
      const firebaseConfig = {
        apiKey: "AIzaSyD0AKFZ-w5PY_-GJMybcuTNEMcG7bXSFGk",
        authDomain: "automation-a3b5e.firebaseapp.com",
        projectId: "automation-a3b5e",
        storageBucket: "automation-a3b5e.appspot.com",
        messagingSenderId: "89418648193",
        appId: "1:89418648193:web:cbda173d8f5e9a79cd5b80"
      }
      initializeApp(firebaseConfig)
      const messaging = getMessaging();
      try {
        console.log('test')

        getToken(messaging,{
          vapidKey: 'BBbsAFHUtJR3wT3frOjM4B3ZfY1VkeT97Yf0AJ13WVuzO0CfiJcBS-FxeYqaMOlwFoa7lXZSI-qQ49JGffHKgqs',
        })
            .then((currentToken) => {
              if (currentToken) {
                this.sendTokenToServer(currentToken)
              } else {
                console.warn('Failed to get token.')
              }
            })
            .catch((err) => {
              console.log(
                  'An error occurred while retrieving token. ',
                  err
              )
              this.setTokenSentToServer(false)
            })
      } catch (e) {
        console.log(e)
      }
    },
    isTokenSentToServer(currentToken) {
      return (
          window.localStorage.getItem('sentFirebaseMessagingToken') ===
          currentToken
      )
    },
    setTokenSentToServer(currentToken) {
      window.localStorage.setItem(
          'sentFirebaseMessagingToken',
          currentToken ? currentToken : ''
      )
    },
    sendTokenToServer(currentToken) {
      if (!this.isTokenSentToServer(currentToken)) {
        this.$http
            .patch('fcm-token', { token: currentToken })
            .then((data) => {
              if (data.data.status) {
                this.setTokenSentToServer(currentToken)
              }
            })
      }
    },
  },
  created() {
    localize('fa', {
      messages: farsi.messages,
    })
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
